import {CalculatorBase} from "./CalculatorBase";
import {FieldTypeEnum} from "FormBuilder/Fields/Core/FBFieldBase.options";
import {FBFieldWithPriceBaseModel} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Model";
import {FBColumnModel} from "FormBuilder/Core/FBColumn.Model";
import {FBFieldWithPriceBaseOptions} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Options";
import {EventManager} from "shared/core/Events/EventManager";
import {CalculateFormula} from "FormBuilder/Events/CalculateFormula";


export class formulaCalculator extends CalculatorBase{

    private CustomSalePrice:number;
    private CustomRegularPrice:number;

    constructor() {
        super();
        this.CustomSalePrice=null;
        this.CustomRegularPrice=null;

    }


    GetDependsOnOtherFields(): boolean {
        return true;
    }

    public SetRegularPrice(price:any)
    {
        this.CustomRegularPrice=price;
        return this;
    }

    public SetSalePrice(price:any)
    {
        this.CustomSalePrice=price;
        return this;
    }

    public get FormulaManager(){
        return this.Field.FormulaManager;
    }


    ExecuteAndUpdate(forceUpdate: boolean = false, skipValueChangedEvent: boolean = false): boolean {
        return true;
    }

    Initialize(Field: FBFieldWithPriceBaseModel<FBFieldWithPriceBaseOptions, FBColumnModel>): this {
        super.Initialize(Field);


        return this;
    }

    public ExecuteCalculation(value:any):{RegularPrice:any,SalePrice:any,Quantity:number}   {
        return {SalePrice:'',RegularPrice:'',Quantity:0};

    }





    public ParseNumber(number:any)
    {
        let num=parseFloat(number);
        if(isNaN(num))
            return 0;
        return num;
    }

}